document.addEventListener("DOMContentLoaded", function () {
  const toTopLink = document.querySelector(".to-top-link");
  if (!toTopLink) return;

  document.addEventListener("scroll", function () {
    if (window.scrollY > 500) {
      toTopLink.classList.remove("hidden");
    } else {
      toTopLink.classList.add("hidden");
    }
  });
});